/*****************************************************************************
 * Open MCT, Copyright (c) 2014-2021, United States Government
 * as represented by the Administrator of the National Aeronautics and Space
 * Administration. All rights reserved.
 *
 * Open MCT is licensed under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * Open MCT includes source code licensed under additional open source
 * licenses. See the Open Source Licenses file (LICENSES.md) included with
 * this source code distribution or the Licensing information page available
 * at runtime from the About dialog for additional information.
 *****************************************************************************/

define(
    ['./TelemetryHandle'],
    function (TelemetryHandle) {

        /**
         * A TelemetryRequester provides an easy interface to request
         * telemetry associated with a set of domain objects.
         *
         * @memberof platform/telemetry
         * @constructor
         * @param $q Angular's $q
         */
        function TelemetryHandler($q, telemetrySubscriber) {
            this.$q = $q;
            this.telemetrySubscriber = telemetrySubscriber;
        }

        /**
         * Start receiving telemetry associated with this domain object
         * (either directly, or via delegation.)
         * @param {DomainObject} domainObject the domain object
         * @param {Function} callback callback to invoke when new data is
         *        available
         * @param {boolean} lossless true if the callback should be invoked
         *        one separate time for each new latest value
         * @returns {TelemetryHandle} a handle to telemetry data
         *          associated with this object
         */
        TelemetryHandler.prototype.handle = function (domainObject, callback, lossless) {
            var subscription = this.telemetrySubscriber.subscribe(
                domainObject,
                callback,
                lossless
            );

            return new TelemetryHandle(this.$q, subscription);
        };

        return TelemetryHandler;

    }
);
